import {Injectable} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {resolveApiBase} from "../../core/api-base";
import {Observable} from "rxjs";
import type {CaptchaToken} from "../../services/captcha.service";

@Injectable({
    providedIn: 'root'
})
export class LoginService {
    constructor(private http: HttpClient) {}

    login(email: string, password: string, clientId: string, captcha?: CaptchaToken, deviceUserCode?: string, correlationId?: string): Observable<any> {
        const body: Record<string, string> = {
            // Emails are stored/looked-up canonically lowercase — normalize before send.
            username: email.trim().toLowerCase(),
            password: password,
            client_id: clientId
        }
        // Story 54.4 — the selected provider's field only (recaptcha_token or
        // altcha_payload); the backend reads nothing else.
        if (captcha) {
            body[captcha.field] = captcha.value;
        }
        // Story 32.4 device sign-in round-trip: when reached via
        // /login?device_user_code=XXXX there is no client_id, so carry the user_code
        // and the backend resolves the client from the DeviceCode.
        if (deviceUserCode) {
            body['device_user_code'] = deviceUserCode;
        }
        // Story 49.6 — the flow's correlation id /authorize handed over on the
        // redirect; the backend adopts it only when it has the platform's own
        // shape, so nothing here validates it.
        if (correlationId) {
            body['correlation_id'] = correlationId;
        }

        // Story 53.9 — no session header: the session travels only in the
        // host-only, HttpOnly cookie the browser attaches (withCredentials), and
        // nothing JS-readable holds it. A request with no credentials is the
        // silent sign-in attempt; the backend answers it from the cookie.
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        });

        return this.http.post<any>(
            `${resolveApiBase()}/login`,
            body,
            {
                headers: headers,
                withCredentials: true
            });
    }
}
